import { authStorageService } from "../auth-storage-service";
import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import packageJson from "../../../../package.json";
import { appConfig } from "@shared/utils/appConfig";

class DatadogService {
  private static instance = new DatadogService();
  constructor() {
    if (DatadogService.instance) {
      return DatadogService.instance;
    }
  }

  private getUserData() {
    const authInfo = authStorageService.get();
    if (!authInfo || !authInfo.email) return null;
    return {
      id: String(authInfo.email),
      email: authInfo.email,
      name: authInfo.name,
      allowedMlsProviders: (authInfo.allowedMlsProviders || []).join(","),
    };
  }

  setUser() {
    const user = this.getUserData();
    if (user) {
      datadogRum.setUser(user);
      datadogLogs.setUser(user);
    }
  }

  clearUser() {
    datadogRum.clearUser();
    datadogLogs.clearUser();
  }

  init() {
    this.initDatadogRum();
    this.initDatadogLogs();
  }

  getDatadogUser() {
    const datadogRumUser = datadogRum.getUser();
    const datadogLogsUser = datadogLogs.getUser();
    if (
      !datadogRumUser ||
      Object.keys(datadogRumUser).length === 0 ||
      !datadogLogsUser ||
      Object.keys(datadogLogsUser).length === 0
    ) {
      return null;
    }

    return datadogRumUser.email === datadogLogsUser.email
      ? datadogRumUser
      : null;
  }

  initDatadogLogs() {
    if (!appConfig.DATADOG_APPLICATION_ID || !appConfig.DATADOG_CLIENT_TOKEN) {
      console.debug("Datadog Logs is not configured.");
      return;
    }
    if (navigator.webdriver) {
      return;
    }
    const initConfig = datadogLogs.getInitConfiguration();
    if (!initConfig) {
      datadogLogs.init({
        clientToken: appConfig.DATADOG_CLIENT_TOKEN,
        site: "us5.datadoghq.com",
        service: packageJson.name,
        version: `${packageJson.version}-${appConfig.COMMIT_SHA}`,
        env: appConfig.APP_ENV,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
      });
    }

    const user = this.getUserData();
    if (user) {
      datadogLogs.setUser(user);
    } else {
      datadogLogs.clearUser();
    }
  }

  initDatadogRum() {
    if (!appConfig.DATADOG_APPLICATION_ID || !appConfig.DATADOG_CLIENT_TOKEN) {
      console.debug("Datadog RUM is not configured.");
      return;
    }
    if (navigator.webdriver) {
      console.debug("Datadog RUM is disabled in headless/automated context.");
      return;
    }
    const initConfig = datadogRum.getInitConfiguration();
    if (!initConfig) {
      datadogRum.init({
        applicationId: appConfig.DATADOG_APPLICATION_ID,
        clientToken: appConfig.DATADOG_CLIENT_TOKEN,
        site: "us5.datadoghq.com",
        service: packageJson.name,
        version: `${packageJson.version}-${appConfig.COMMIT_SHA}`,
        env: appConfig.APP_ENV,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        traceSampleRate: 100,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        defaultPrivacyLevel: "mask-user-input",
      });
    }

    const user = this.getUserData();
    if (user) {
      datadogRum.setUser(user);
    } else {
      datadogRum.clearUser();
    }
  }
}

export const datadogService = Object.freeze(new DatadogService());
